import useStartet from '@/hooks/useStartet';

import Table from '@/components/Table/table';

const Startet = () => {
  const { data, loading, columns } = useStartet();

  return (
    <div className="mt-4">
      {loading ? (
        <p className="text-center mt-4">Indlæser data...</p>
      ) : (
        <Table data={data} columns={columns} isSwitch={false} isImport={true}/>
      )}
    </div>
  );
};

export default Startet;
